var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 23C18.4477 23 18 22.5523 18 22L18 0.999998C18 0.447714 18.4477 -1.95703e-08 19 -4.37114e-08L25 -3.0598e-07C25.5523 -3.30121e-07 26 0.447714 26 0.999998L26 22C26 22.5523 25.5523 23 25 23L19 23Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.2727V15.7273C26 15.4318 25.8928 15.1761 25.6784 14.9602C25.464 14.7443 25.2101 14.6364 24.9167 14.6364H13V8.09091C13 7.77273 12.8984 7.51136 12.6953 7.30682C12.4922 7.10227 12.2326 7 11.9167 7C11.6458 7 11.375 7.11364 11.1042 7.34091L0.304688 18.2159C0.101562 18.4205 0 18.6818 0 19C0 19.3182 0.101562 19.5795 0.304688 19.7841L11.138 30.6932C11.3411 30.8977 11.6007 31 11.9167 31C12.2101 31 12.464 30.892 12.6784 30.6761C12.8928 30.4602 13 30.2045 13 29.9091V23.3636H24.9167C25.2101 23.3636 25.464 23.2557 25.6784 23.0398C25.8928 22.8239 26 22.5682 26 22.2727Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.eca661b21ed7ad67b4ff5c8ad8137ec1.svg";
export { ForwardRef as ReactComponent };